import React from 'react';
import logo from './logo.svg';
import './App.css';
import QuestionModel from './QuestionModel.js';

class Mistakes extends React.Component {
	
  handleSubmit = (user) => {
  }
  
  constructor(props) {
		super(props);
		this.state = {
			correctQuestionCount : props.correctQuestionCount
		}
  }

  render(props) {
	  let missedQuestions = this.props.missedQuestions;
	  const maxQuestions = 5;
	  while (missedQuestions.length > maxQuestions) {
		missedQuestions.shift();
	  }
	  
	  var myQuestionModel = new QuestionModel(true, "all");	// if they missed one from grownUpMode go ahead and show it
	  let listQuestions = missedQuestions.map((question) =>
		<div className="card-static">
			<header>
				<div className="line-static">
					{myQuestionModel.getVerseByReference(question)}
				</div>
				<div class="blueline"/>
				<div className="line-static">
				{question}
				</div>
			</header>
		</div>
		
	  );
	  
	  if (missedQuestions.length == 0 ) {
		  listQuestions =
			<div className="card-static">
				<header>
					<div className="line-static">
					If any of you lacks wisdom,<br/>let him ask God,<br/>who gives generously to all without reproach,<br/>and it will be given him.
					</div>
					<div class="blueline"/>
					<div className="line-static">
						James 1:5 ESV
					</div>
				</header>
			</div>
	  }
	  
	  return (
		<div className="App">
		
			{listQuestions}

			
		</div>
	  );
  }
}

export default Mistakes;
